import React from "react";
import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  useBreakpointValue,
} from "@chakra-ui/react";
import { PrivacyPolicyContent } from "containers/Pages/Legal/PrivacyPolicy";
import { TermsOfServiceContent } from "containers/Pages/Legal/TermsOfService";

const ModalLinkButton = ({ children, content, title, linkSize, ...buttonProps }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const modalSize = useBreakpointValue({ base: "full", md: "lg" });

  return (
    <>
      {/*
       * buttonProps is how callers set the type styles a Button does NOT inherit from the text
       * around it: the UA stylesheet applies a `font:` shorthand to <button>, and Chakra's reset
       * restores family, size and weight from it but not `font-style` - so italic copy containing
       * one of these links renders the link upright unless it is passed down.
       */}
      <Button
        onClick={onOpen}
        variant="link"
        size={linkSize}
        data-testid="modal-link-button"
        {...buttonProps}
      >
        {children}
      </Button>

      <Modal
        isOpen={isOpen}
        onClose={onClose}
        size={modalSize}
        scrollBehavior="inside"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{title}</ModalHeader>
          <ModalCloseButton />
          <ModalBody
            display="flex"
            as="div"
            data-testid="modal-api-link-div"
            title={title}
            sx={{
              border: 0,
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
            }}
            mb={8}
            minH={modalSize === "full" ? "100%" : "400px"}
          >
            {content}
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export const TOSModalLinkButton = ({ label = "Terms of Service", size = "md", ...buttonProps }) => (
  <ModalLinkButton
    title="Tilia Terms of Service"
    content={<TermsOfServiceContent />}
    linkSize={size}
    {...buttonProps}
  >
    {label}
  </ModalLinkButton>
);

export const PrivacyPolicyModalLinkButton = ({
  label = "Privacy Policy",
  size = "md",
  ...buttonProps
}) => {
  return (
    <ModalLinkButton
      title="Tilia Privacy Policy"
      content={<PrivacyPolicyContent />}
      linkSize={size}
      {...buttonProps}
    >
      {label}
    </ModalLinkButton>
  );
};
